export function mapItemTemplate(content) {
	return `
    <div class="pr-[60px] pl-[75px] h-full flex-shrink-0 overflow-hidden w-full max-w-full xl:pl-35 xl:pr-[35px] sm:px-0 sm:relative sm:mt-0" data-banners="infoListItem">
      <div class="mb-[38px] text-dark-blue sm:mb-[0px]" data-banners="headerTxt">
        <div class="text-[23px] sm:hidden" data-banners="question">${content.question}</div>
        <div class="sub-tt mb-[13px] -sm is-hidden sm:pt-[12px]" data-banners="nameCountry">${
			content.visibleCountryName || content.nameCountry[0]
		}</div>
        <h2 class="is-hidden h3 -sm sm:mt-[12px] sm:pb-[25px] xs:pb-[16px]" data-banners="name">${content.nameDish}</h2>
      </div>
      <div class="border-gold border-[1px] border-solid mb-[29px] text-center sm:mb-0 ${
			content.imgPositionMobile
		}" data-banners="imgContainer">
        <img class="sm:w-full align-bottom" src="${content.img}" alt="image" data-banners="img" />
      </div>
      <div>
        <button class="btn -animate btn-st -border -dark h-[67px] min-w-[343px] xl:w-full xl:min-w-[10px] sm:h-[55px] sm:max-w-[280px]" data-banners="btnToHint">REVEAL HINT</button>
        <span class="hint is-hidden text-left" data-banners="hint">${content.hint}</span>
      </div>
      <div class="mt-[14px] text-left is-hidden text-dark-brown xl:px-0 sm:pb-10 xs:pb-10 sm:mt-[24px]" data-banners="text">
				<div class="txt-default">
					${content.text}
				</div>
				<button class="button-open-text w-[calc(100%+20px)] xl:w-auto is-active" data-banners="btnOpenText">
					DISCOVER THE MAKING OF YOUR IN-FLIGHT MEAL
				</button>
				<div class="block-open-text txt-default" data-banners="blockOpenText">
						<div class="block-open-text_inner sm:pb-30">
							${content.textOpen}
						</div>
				</div>
			</div>
    </div>
  `;
}
